export const PROJECT_CATEGORIES = {
  UXUI: { key: "uxui", label: "UX/UI Design" },
  VDXR: { key: "vdxr", label: "Videogames & XR" },
  OTHER: { key: "other", label: "Other" },
};

export const EXPERIENCE_CATEGORIES = {
  EXPERIENCE: { key: "experience", label: "Experience" },
  EDUCATION: { key: "Education", label: "Education" },
};
